import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';
import { ProtectedRoute } from '@/components/layout/ProtectedRoute';

const DocsSpacesListPage = lazy(() => import('./DocsSpacesListPage'));
const DocsSpaceDetailPage = lazy(() => import('./DocsSpaceDetailPage'));
const DocsPagesListPage = lazy(() => import('./DocsPagesListPage'));
const DocsPageDetailPage = lazy(() => import('./DocsPageDetailPage'));
const DocsSharingPage = lazy(() => import('./DocsSharingPage'));
const DocsTrashPage = lazy(() => import('./DocsTrashPage'));

export const docsRoutes: RouteObject[] = [
  {
    path: 'docs',
    element: (
      <ProtectedRoute action="docs:view">
        <DocsSpacesListPage />
      </ProtectedRoute>
    ),
  },
  {
    path: 'docs/spaces/:id',
    element: (
      <ProtectedRoute action="docs:view">
        <DocsSpaceDetailPage />
      </ProtectedRoute>
    ),
  },
  {
    path: 'docs/pages',
    element: (
      <ProtectedRoute action="docs:view">
        <DocsPagesListPage />
      </ProtectedRoute>
    ),
  },
  {
    path: 'docs/pages/:id',
    element: (
      <ProtectedRoute action="docs:view">
        <DocsPageDetailPage />
      </ProtectedRoute>
    ),
  },
  {
    path: 'docs/sharing',
    element: (
      <ProtectedRoute action="docs:view">
        <DocsSharingPage />
      </ProtectedRoute>
    ),
  },
  {
    path: 'docs/trash',
    element: (
      <ProtectedRoute action="docs:view">
        <DocsTrashPage />
      </ProtectedRoute>
    ),
  },
];
